module.exports = __webpack_public_path__ + "img/english.dd9c82b6.png";